import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { getGalleryFolders, getGalleryImages } from "../../api";
import CustomLoader from "../../utils/CustomLoader";
import "./gallery.css";

const Gallery = () => {
  const [folders, setFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [error, setError] = useState("");

  const baseurl = window.location.origin.includes("localhost")
    ? "https://brtravels.co.in"
    : window.location.origin;

  /* ================= FETCH FOLDERS ================= */
  useEffect(() => {
    const fetchFolders = async () => {
      setLoading(true);
      setError("");

      try {
        const res = await getGalleryFolders();

        // 👇 artificial 2 sec delay
        setTimeout(() => {
          if (Array.isArray(res.data)) {
            setFolders(res.data);
          }
          setLoading(false);
        }, 2000);
      } catch {
        setError("Failed to fetch gallery folders");
        setLoading(false);
      }
    };

    fetchFolders();
  }, []);

  /* ================= FETCH IMAGES ================= */
  useEffect(() => {
    if (!selectedFolder) return;

    const fetchImages = async () => {
      setLoading(true);
      setError("");

      try {
        const res = await getGalleryImages(selectedFolder.name);

        setTimeout(() => {
          if (Array.isArray(res.data)) {
            setImages(
              res.data.map((img) => ({
                src: baseurl + img,
              }))
            );
          }
          setLoading(false);
        }, 2000); // 👈 2 sec delay
      } catch {
        setError("Failed to fetch images");
        setLoading(false);
      }
    };

    fetchImages();
  }, [selectedFolder]);

  /* ================= FOLDERS VIEW ================= */
  if (!selectedFolder) {
    return (
      <section className="gallery-section">
        <h2 className="gallery-title">Gallery</h2>
        {loading ? (
          <CustomLoader text="Loading gallery..." color="#FF577F" />
        ) : folders.length === 0 ? (
          <div className="no-gallery">No Gallery Found</div>
        ) : (
          <div className="folder-grid">
            {folders.map((folder, i) => (
              <div
                key={i}
                className="folder-card"
                onClick={() => setSelectedFolder(folder)}
              >
                <div className="folder-thumb">
                  <img src={baseurl + folder.thumbnail} alt={folder.name} />
                </div>

                <div className="folder-name">{folder.name}</div>
              </div>
            ))}
          </div>
        )}

        {error && <p className="gallery-error">{error}</p>}
      </section>
    );
  }

  /* ================= IMAGES VIEW ================= */
  return (
    <section className="gallery-section">
      <h2 className="gallery-title">{selectedFolder.name} Gallery</h2>

      <button
        className="gallery-back-btn"
        onClick={() => setSelectedFolder(null)}
      >
        ← Back to Folders
      </button>

      {loading && <CustomLoader text="Loading images..." color="#FF577F" />}

      {error && <p className="gallery-error">{error}</p>}

      {!loading && images.length === 0 ? (
        <div className="no-gallery">No Gallery Found</div>
      ) : (
        !loading && (
          <div className="gallery-grid">
            {images.map((img, i) => (
              <div
                key={i}
                className="gallery-item"
                onClick={() => {
                  setIndex(i);
                  setOpen(true);
                }}
              >
                <img src={img.src} alt="Gallery" />
              </div>
            ))}
          </div>
        )
      )}

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={images}
      />
    </section>
  );
};

export default Gallery;
